import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Same gerns-world project as web-admin — deliberately, so the register
// accepts the exact same accounts as admin with no separate user
// directory to maintain. These values identify the project; they're not
// secrets and are safe in the client bundle.
const firebaseConfig = {
  apiKey: 'AIzaSyAPItpc3ztudKKDfrUVqZJzk-6goqME7Eg',
  authDomain: 'gerns-world.firebaseapp.com',
  projectId: 'gerns-world',
  storageBucket: 'gerns-world.firebasestorage.app',
  messagingSenderId: '44262946707',
  appId: '1:44262946707:web:bdd72588d3ec761d745a66',
  measurementId: 'G-9V7P8GZJG0',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
